import { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from 'react';

import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';

import { parseUnits } from 'ethers';

type GasLimitFormProps = {
    updateValue: Dispatch<SetStateAction<bigint>>
}

const TransactionValueForm = ({ updateValue }: GasLimitFormProps) => {
    const [value, setValue] = useState('0')
    const [units, setUnits] = useState('Wei')
    
    useEffect(() => {
        if (value === '') {
            setValue('0')
        }

        try {
            updateValue(parseUnits(value, units.toLowerCase()))
        } catch (e) {
            console.log(e)
            setValue('0')
        }
    }, [value, units])

    const handleChange = (newValue: string) => {
        if (value === '0') {
            setValue(newValue.slice(1))
        } else {
            setValue(newValue)
        }
    }

    return (
        <Form className='value-form-container'>
            <Form.Group>
                <Form.Label>Value</Form.Label>
                <div className='value-form-control'>
                    <Form.Control size='sm' type='number' defaultValue={0} min={0} value={value} onChange={(e) => handleChange(e.target.value)} />
                    <Dropdown>
                        <Dropdown.Toggle variant='secondary' size='sm'>{units}</Dropdown.Toggle>

                        <Dropdown.Menu>
                            {['Wei', 'Gwei', 'Ether'].map((unit, index) => {
                                return <Dropdown.Item key={index} onClick={() => setUnits(unit)}>{unit}</Dropdown.Item>
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </Form.Group>
        </Form>
    )
}

export default TransactionValueForm